import "./App.css";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PreIEO_ABI from "./PrieIEO.json";

import Landing from "./pages/landing/Landing";
import Dex from "./pages/dex/Dex";
import CommingSoonDex from "./pages/comming_soon/CommingSoonDex";
import TokenSale from "./pages/tokensale/TokenSale.tsx";
import Dashboard from "./pages/dashboard/Dashboard";
import Staking from "./pages/staking/Staking";
import StakingDashboard from "./pages/staking/Staking_Dashboard/StakingDashboard.tsx";

import "@rainbow-me/rainbowkit/styles.css";
import { useAccount } from "wagmi";
import {
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { mainnet, polygon, optimism, arbitrum } from "wagmi/chains";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import Policies from "./pages/policies/Policies";
import CommingSoonTokenSale from "./pages/comming_soon/CommingSoonTokenSale";
import React from "react";

const { chains, publicClient } = configureChains(
  [mainnet, polygon, optimism, arbitrum],
  [alchemyProvider({ apiKey: process.env.ALCHEMY_ID }), publicProvider()]
);

const { connectors } = getDefaultWallets({
  appName: "My RainbowKit App",
  projectId: "30980df3d204e25c5ae7cfe90918d5ef",
  chains,
});

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

function App() {
  const { address: account, isConnecting, isDisconnected } = useAccount();
  const [contractInstance, setContractInstance] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const contractAddress = "0x3bbd9d1c1EB5d033fD7a643536AFa0a34ABf8A6C";

  useEffect(() => {
    const loadContract = async () => {
      try {
        if (window.ethereum && account) {
          await window.ethereum.enable();
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            PreIEO_ABI,
            signer
          );
          setContractInstance(contract);
          if (account === "0x83aB680a4BEc9b8be243FDf790D920DEbFb968FD") {
            setIsOwner(true);
          }
        } else {
          // console.log("Please install MetaMask!");
        }
      } catch (error) {
        console.error("Error loading contract:", error);
      }
    };

    loadContract();
  }, [account]);

  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider
        chains={chains}
        theme={darkTheme({
          accentColor: "#0077ff",
          accentColorForeground: "white",
          borderRadius: "large",
        })}
      >
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="" element={<Landing />} />
              <Route
                path="/dex*"
                element={<Dex account={account} contract={contractInstance} />}
              />
              <Route path="/dexx" element={<CommingSoonDex />} />
              <Route
                path="/token-sale"
                element={
                  <TokenSale
                    account={account}
                    contract={contractInstance}
                    isOwner={isOwner}
                  />
                }
              />
              <Route path="/token-salee" element={<CommingSoonTokenSale />} />

              <Route path="/policies" element={<Policies />} />
              <Route
                path="/dashboard"
                element={
                  <Dashboard
                    account={account}
                    contract={contractInstance}
                    isOwner={isOwner}
                  />
                }
              />
              <Route
                path="/staking"
                element={
                  <Staking
                    account={account}
                    contract={contractInstance}
                    isOwner={isOwner}
                  />
                }
              />
              <Route
                path="/staking-dashboard"
                element={<StakingDashboard account={account} />}
                isOwner={isOwner}
              />
            </Routes>
          </BrowserRouter>
        </div>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}

export default App;

// [[redirects]]
// from = "/*"
// to = "/index.html"
// status = 200

{
  /* <IfModule mod_rewrite.c>
  RewriteEngine On
  RewriteBase /
  RewriteRule ^index\.html$ - [L]
  RewriteCond %{REQUEST_FILENAME} !-f
  RewriteCond %{REQUEST_FILENAME} !-d
  RewriteCond %{REQUEST_FILENAME} !-l
  RewriteRule . /index.html [L]
</IfModule> */
}
